var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useProfile } from '@brg/auth';
export var withProfile = function (Component) {
    return function WrappedComponent(props) {
        var profile = useProfile();
        return React.createElement(Component, __assign({}, props, { profile: profile }));
    };
};
//# sourceMappingURL=withProfile.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useProfile } from '@brg/auth';
export var withProfile = function (Component) {
    return function WrappedComponent(props) {
        var profile = useProfile();
        return React.createElement(Component, __assign({}, props, { profile: profile }));
    };
};
//# sourceMappingURL=withProfile.js.map